import { HTMLAttributes, memo, useEffect, useRef } from "react";

const DEFAULT_TYPE = "video/mp4";

interface AutoPlayVideoI extends HTMLAttributes<HTMLVideoElement> {
  src: string;
  type?: string;
}

const AutoPlayVideo = memo((props: AutoPlayVideoI) => {
  const { src, type = DEFAULT_TYPE, ...rest } = props;

  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const video = videoRef.current;

    if (video) {
      video.muted = true;
      video.setAttribute("playsinline", "");
      video.setAttribute("autoplay", "true");

      video.onloadeddata = () => {
        video.play().catch((error) => {
          console.log("Autoplay failed:", error);
        });
      };
    }
  }, []);

  return (
    <video {...rest} ref={videoRef} autoPlay muted loop playsInline>
      <source src={src} type={type} />
    </video>
  );
});

export default AutoPlayVideo;
